// extracted by mini-css-extract-plugin
export default {"icon":"RecentSignal_icon__8ig4u"};